import { createSlice } from '@reduxjs/toolkit'

export interface ToastState {
  isLoading: boolean
}

const initialState: ToastState = {
  isLoading: false,
}

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    changeLoading: (state, { payload }) => {
      state.isLoading = payload
    },
  },
  extraReducers: {},
})

export const { actions, reducer } = loadingSlice
export const { changeLoading } = actions
